<template>
  <div>
    <el-card shadow="never" style="margin-bottom: 10px">
      <div class="d-flex justify-content-between align-items-center">
        <div
          class="d-flex align-items-center"
          style="overflow: hidden;margin-bottom: 10px;"
        >
          <div class="header-wrapper">
            <div class="header-icon" />
          </div>
          <div class="flex-1 ml-2">
            <h5 style="color: #101010" v-if="!baseInfo.applyTitle">
              {{ '新增订单验货申请' }}
            </h5>
            <h5 v-else style="color: #101010">
              {{ baseInfo.applyTitle }}
            </h5>
            <p
              style="font-size: 14px; color: #6c6c6c"
              class="m-0 text-truncate"
            >
              <span> No：{{ baseInfo.applyNo || '编号自动生成' }} </span>
              <el-divider direction="vertical" v-if="baseInfo.applyStatus" />
              <el-tag
                size="mini"
                :type="applyStatusTagType(baseInfo)"
                v-if="baseInfo.applyStatus"
              >
                {{ baseInfo.applyStatusText || baseInfo.applyStatus }}
              </el-tag>
              <el-divider
                direction="vertical"
                v-if="baseInfo.inspectionApplyCode"
              />
              <span v-if="baseInfo.inspectionApplyCode">
                Modify：{{ baseInfo.modifyByName || '--' }} at
                {{ baseInfo.modifyTime || '--' }}
              </span>
            </p>
          </div>
        </div>
        <div
          style="height: 100%;"
          class="mt-4"
          v-if="!disabled && activeName == 'info'"
        >
          <el-button type="primary" size="mini" @click="saveByActiveTab">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="info-card">
      <div class="switch-tabs_wrappers mb-2">
        <div class="switch-tabs">
          <div
            v-for="item in switchTabs"
            :key="item.value"
            class="switch-tabs_items"
            :class="{
              active: item.value === activeName,
              disabled: item.disabled,
            }"
            @click="handleTabClick(item)"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>

      <EditForm
        ref="editForm"
        v-show="activeName === 'info'"
        :disabled="disabled"
        :auditDisabled="auditDisabled"
        :inspectionApplyCode="inspectionApplyCode"
        @loaded="loaded"
      />
      <InspectionDetailMaterial
        ref="inspectionDetailMaterial"
        v-show="activeName === 'detail'"
        :baseInfo="baseInfo"
        :disabled="disabled"
        :inspectionApplyCode="inspectionApplyCode"
        @setOrderNos="$refs.editForm.setOrderNos()"
      />
      <InspectionDetailReport
        ref="inspectionDetailReport"
        v-show="activeName === 'report'"
        :inspectionApplyCode="inspectionApplyCode"
        :disabled="disabled"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import InspectionDetailMaterial from '../components/edit-form/inspection-detail-material/index.vue'
import InspectionDetailReport from '../components/edit-form/inspection-detail-report/index.vue'
export default {
  name: 'inspection-apply-detail',
  components: { EditForm, InspectionDetailMaterial, InspectionDetailReport },
  data() {
    return {
      baseInfo: {},
      activeName: 'info',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return ['detail', 'auditEdit'].includes(this.pageType)
    },
    auditDisabled() {
      return this.pageType != 'auditEdit'
    },
    inspectionApplyCode() {
      return this.params.code
    },
    switchTabs() {
      return [
        {
          label: this.$l('form_label_applyInfo') || '申请信息',
          value: 'info',
        },
        {
          label: this.$l('form_label_inspectionDetailMaterial') || '验货明细及资料',
          value: 'detail',
          disabled: !this.inspectionApplyCode,
        },
        {
          label: this.$l('form_label_inspectionReport') || '验货报告',
          value: 'report',
          disabled: !this.inspectionApplyCode,
        },
      ]
    },
  },
  methods: {
    handleTabClick(item) {
      if (!item || item.disabled) return
      this.activeName = item.value
      if (item.value !== 'report') return
      this.$nextTick(() => {
        this.$refs.inspectionDetailReport?.refreshData?.()
      })
    },
    saveByActiveTab() {
      return this.$refs.editForm?.save()
    },
    loaded(d) {
      this.baseInfo = { ...d }
    },
    applyStatusTagType({ applyStatus }) {
      const code = `${applyStatus || ''}`
      if (code === '5') return 'danger'
      if (code === '4') return 'success'
      if (code === '3') return 'warning'
      if (code === '2') return ''
      return 'info'
    },
  },
}
</script>
<style lang="scss" scoped>
.header-wrapper {
  width: 60px;
  height: 60px;
  min-width: 60px;
  background-image: url('./polygonal.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
  .header-icon {
    width: 30px;
    height: 30px;
    background-image: url('./document.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 20px 4px 16px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 35px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    border-bottom: 3px solid #1989fa;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
    border-bottom: 3px solid #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding-bottom: 10px;
  }
  .info-card .el-card__body {
    padding-top: 0px;
  }
}
</style>
